import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listArticles } from "@/lib/api";
import { ArrowRight, Clock } from "@phosphor-icons/react";

export default function Blog() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listArticles().then((d) => { setArticles(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const featured = articles[0];
  const rest = articles.slice(1);

  return (
    <div data-testid="page-blog">
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 lg:py-28 border-b border-ink/10">
          <p className="overline">Journal</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight text-ink max-w-4xl">
            Essays, dispatches, and field reports from the WinWorld circle.
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        {loading && <p className="text-ink/50">Loading articles...</p>}

        {featured && (
          <Link to={`/blog/${featured.slug}`} className="block group" data-testid="blog-featured">
            <div className="grid lg:grid-cols-12 gap-10 items-center">
              <div className="lg:col-span-7 relative aspect-[16/10] overflow-hidden rounded-3xl ring-1 ring-ink/10">
                <img src={featured.cover_image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="lg:col-span-5">
                <p className="overline">{featured.category}</p>
                <h2 className="mt-3 font-display text-3xl lg:text-5xl text-ink font-light leading-[1.1] tracking-tight">{featured.title}</h2>
                <p className="mt-5 text-lg text-ink/65 leading-relaxed">{featured.excerpt}</p>
                <div className="mt-6 flex items-center gap-4 text-xs uppercase tracking-widest text-ink/50">
                  <span>{featured.author}</span>
                  <span className="inline-flex items-center gap-1"><Clock size={12} /> {featured.read_minutes} min</span>
                </div>
                <div className="mt-8 inline-flex items-center gap-2 text-ink group-hover:text-gold transition-colors text-sm font-medium">
                  Read essay <ArrowRight size={14} weight="bold" />
                </div>
              </div>
            </div>
          </Link>
        )}
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-list">
          {rest.map((a) => (
            <Link key={a.id} to={`/blog/${a.slug}`} className="group bg-white rounded-2xl overflow-hidden ring-1 ring-ink/10 card-shadow hover:-translate-y-1 transition-transform" data-testid={`article-${a.slug}`}>
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <span className="absolute top-3 left-3 text-[10px] tracking-widest uppercase bg-white/90 text-ink px-2 py-1 rounded">{a.category}</span>
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl text-ink leading-snug">{a.title}</h3>
                <p className="mt-2 text-sm text-ink/60 line-clamp-3">{a.excerpt}</p>
                <div className="mt-4 flex items-center gap-4 text-xs uppercase tracking-widest text-ink/50">
                  <span>{a.author}</span>
                  <span className="inline-flex items-center gap-1"><Clock size={12} /> {a.read_minutes} min</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
